var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBlueListWhiteBgShortRoundLightBlueBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 3.5,
    stroke: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.55 5.9H17.1C18.315 5.9 19.3 6.88497 19.3 8.1V18.3C19.3 19.515 18.315 20.5 17.1 20.5H8.29998C7.08495 20.5 6.09998 19.515 6.09998 18.3V8.1C6.09998 6.88497 7.08495 5.9 8.29998 5.9H8.84995C9.16998 5.08053 9.96718 4.5 10.9 4.5H14.5C15.4328 4.5 16.23 5.08053 16.55 5.9ZM8.78279 7.9H8.29998C8.18952 7.9 8.09998 7.98954 8.09998 8.1V18.3C8.09998 18.4105 8.18952 18.5 8.29998 18.5H17.1C17.2104 18.5 17.3 18.4105 17.3 18.3V8.1C17.3 7.98954 17.2104 7.9 17.1 7.9H16.6172C16.356 8.8234 15.507 9.5 14.5 9.5H10.9C9.89295 9.5 9.04396 8.8234 8.78279 7.9ZM10.7 6.7C10.7 6.58954 10.7895 6.5 10.9 6.5H14.5C14.6104 6.5 14.7 6.58954 14.7 6.7V7.3C14.7 7.41046 14.6104 7.5 14.5 7.5H10.9C10.7895 7.5 10.7 7.41046 10.7 7.3V6.7Z",
    fill: "#5062F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89998 11.7C8.89998 11.1477 9.34769 10.7 9.89998 10.7H15.5C16.0523 10.7 16.5 11.1477 16.5 11.7C16.5 12.2523 16.0523 12.7 15.5 12.7H9.89998C9.34769 12.7 8.89998 12.2523 8.89998 11.7Z",
    fill: "#5062F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89998 15.7C8.89998 15.1477 9.34769 14.7 9.89998 14.7H15.5C16.0523 14.7 16.5 15.1477 16.5 15.7C16.5 16.2523 16.0523 16.7 15.5 16.7H9.89998C9.34769 16.7 8.89998 16.2523 8.89998 15.7Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBlueListWhiteBgShortRoundLightBlueBorder);
export default __webpack_public_path__ + "static/media/lightBlueListWhiteBgShortRoundLightBlueBorder.a6cac4149ed41a6bb29f411854d4a8c9.svg";
export { ForwardRef as ReactComponent };